import _ from 'lodash'

export default {
    state: {
        quotas: {
            emailReveals: { used: 0, remaining: 0, allocated: 0, },
            discovery: { used: 0, remaining: 0, allocated: 0, },
            exports: { used: 0, remaining: 0, allocated: 0 },
            profileUnlocks: { used: 0, remaining: 0, allocated: 0 },
            reportGeneration: { used: 0, remaining: 0, allocated: 0 },
        },

        resetDate: null,
    },

    /* eslint-disable no-param-reassign */
    mutations: {
        'quota:update': function (state, { type, key, value }) {
            if (state.quotas[type]) {
                state.quotas[type][key] = value
            }
        },
        'quota:resetDate': function (state, { newResetDate }) {
            state.resetDate = newResetDate
        },

        /* eslint-enable no-param-reassign */
    },

    getters: {
        quota(state) {
            return state
        },

        quotaUsed: (state) => ({quotaType}) => {
            return state.quotas[quotaType].used
        },

        quotaRemaining: (state) => ({quotaType}) => {
            return state.quotas[quotaType].remaining
        },

        quotaAllocated: (state) => ({quotaType}) => {
            return state.quotas[quotaType].allocated
        },

        quotaResetDate(state) {
            return state.resetDate
        }
    },
}
